export const DOMAIN_DEFAULT = '/';

export const API_CODE_FAILURE = 0;
export const CLIENT_TYPE_BROWSER = 'browser';
export const USER_ROLE_CUSTOMER = 'customer';
export const USER_ROLE_OPERATOR = 'operator';
export const USER_ROLE_WRITER = 'writer';
export const USER_ROLE_SEO = 'seo';

export const PAPER_SIZE_VALUES = {
  WORDS: 'words',
  PAGES: 'pages',
};
export const INITIAL_PAPER_SIZE = PAPER_SIZE_VALUES.PAGES;
export const PAGES_MAX = 800;
export const PAGES_MIN = 1;
export const WORDS_MIN = 275;
export const WORDS_MAX = PAGES_MAX * 275;
export const WORDS_TO_NEXT_PAGE_THRESHOLD = 100; // WORDS_TO_NEXT_PAGE in dashboard
export const WORDS_STEP = 100;
export const DEADLINE_FORMAT_CLIENT_DATEPICKER = 'M j at hK';
export const DEADLINE_FORMAT_SERVER_DATEPICKER = 'M j at hK Y';
export const DEADLINE_FORMAT_CLIENT_DATE_FNS = "MMM d 'at' haaa";
export const HOURS_DEFAULT = 12;
export const HOURS_LEFT_MIN = 1;
export const INITIAL_PAPER_TYPE = 200;
export const MAX_LOGIN_LENGTH = 127;

export const ERROR_EMAIL_EMPTY = 'Please enter your email';
export const ERROR_EMAIL_INVALID = 'Please enter a valid email';
export const ERROR_EMAIL_LONG = 'Please enter a valid email (max 127 symbols)';
export const ERROR_PASSWORD_EMPTY = 'Please enter your password to continue';
export const ERROR_PASSWORD_WRONG = 'Wrong password, please try again';
export const ERROR_ACCOUNT_BLOCKED = 'This account is blocked';
export const ERROR_USER_ROLE_INVALID =
  'This email has a different user role. Use "my account" to log in';
export const ERROR_LOGIN_INCORRECT = 'Login incorrect (user not exist)';
export const ERROR_LOGIN_ISSUE = 'Login for this account is not available.';
export const ERROR_POLICY_EMPTY = 'policy_empty';
export const ERROR_DEADLINE_EMPTY = 'Please enter your deadline';
export const ERROR_PAPER_INVALID = 'Please select a correct type of paper';
export const ERROR_DISCIPLINE_INVALID = 'Please enter your discipline';
export const ERROR_DEADLINE_SHORT = 'Deadline can’t be set in the past';
export const ERROR_WORDS_MORE = `At least ${WORDS_MIN} words are required`;
export const ERROR_PAGES_INVALID = `Please enter a value from ${PAGES_MIN} to ${PAGES_MAX}`;
export const ERROR_PAGES_LESS = `Maximum number of pages is ${PAGES_MAX}`;
export const ERROR_PAGES_MORE = 'At least one page is required';
export const ERROR_PASSWORDS_NOT_EQUAL = "Passwords didn't match. Try again";
export const ERROR_RECAPTCHA_GEN = 'Recaptcha generation error';
export const ERROR_PASSWORD_CONTAIN_LETTER = 'Include at least 1 letter';
export const ERROR_PASSWORD_CONTAIN_NUMBER_OR_SPECIAL_CHARACTER =
  'Include at least 1 number or special character';
export const ERROR_PASSWORD_MIN_LENGTH = 'Password must contain at least 8 characters';
export const ERROR_PASSWORD_MAX_LENGTH =
  'This Password field must be contain not more 127 chatacters';
export const ERROR_CODE_INCORRECT = 'Incorrect code';
export const ERROR_CODE_EXPIRED = 'Code is expired';
export const ERROR_CODE_IS_REQUIRED = 'Code is required';

export const STORAGE_USED_PROVIDER = 'bb-used-provider'; // XXX used in dashboard
export const STORAGE_ORDER = 'bb-order';
export const STORAGE_DEBUG = 'bb-debug';

export const AUTH_EVENT_NAME = 'b:auth';
export const LOGOUT_EVENT = 'b:logout';

export const GDPR_PROPS_DEFAULT = {
  termsLink: '/terms-and-conditions.html',
  termsLabel: 'Terms & Conditions',
  policyLink: '/privacy-policy.html',
  policyLabel: 'Privacy Policy',
  termLinkWriter: '/writer-terms-and-conditions.html',
  policyLinkWriter: '/writer-privacy-policy.html',
};

export const DEFAULT_LATEST_ORDERS_CARD_AMOUNT = 4;
export const DISCIPLINE_OTHER_WRITING_ID = 20000;

export const STATIC_FILES_MAP = {
  triple10: 'triple10.svg',
  nineplus: 'nineplus.svg',
  punctuality_proofed: 'punctuality_proofed.svg',
  reliability_proofed: 'reliability_proofed.svg',
  writer_of_month: 'writer_of_month.svg',
  newcomer_of_month: 'newcomer_of_month.svg',
  customer_loyalty: 'customer_loyalty.svg',
  writers_count: 'writers_count.svg',
  writers_online: 'writers_online.svg',
  quality_score: 'quality_score.svg',
  empty: 'empty.svg',
  error: 'error.svg',
};

export const Status = {
  ok: 'ok',
  error: 'error',
};
